module.exports = __webpack_public_path__ + "static/media/chart-placeholder.70841006.svg";